export default {
  SHOW_WEB3_CONFIRM_MODAL: 'showWeb3Wallet',
  SHOW_TX_CONFIRM_MODAL: 'showTxConfirmModal',
  SHOW_MSG_CONFIRM_MODAL: 'showMessageConfirmModal',
  SHOW_TX_SIGN_MODAL: 'showTxSignModal'
};
